module.exports = __webpack_public_path__ + "img/signup-partb-3m-before-retire.b3db50e.png";